export interface IIncome {
	id: string
	_id: string
	type: EIncomeType
	province: EProvince
	institution?: Entities.Institution.Object
	entity?: Entities.Entity.Object
	program?: Entities.Program.Object
	level: EIncomeLevel
	amount: number
	originType: EIncomeOriginTypeCorriente | EIncomeOriginTypeCapital
	originName: string
	originNature: EIncomeOriginNature
	originID: string
	note: string
	date: Date
	year: number
	quarter: number
	metadata: {
		createdAt: Date
		updatedAt: Date
	}
}

export enum EIncomeLevel {
	Federal = 'federal',
	Quarter = 'quarter',
	Institution = 'institution',
	Entity = 'entity',
	Program = 'program',
}

export enum EIncomeType {
	Capital = 'capital',
	Corriente = 'corriente',
}

export enum EIncomeOriginNature {
	Privado = 'privado',
	Particular = 'particular',
	Publico = 'público',
}

export interface ITreemapIncomeAggregation {
	title: string
	size: number
	level: EIncomeLevel
}

export enum EIncomeOriginTypeCorriente {
	Operacion = 'operación',
	TransferenciasCorrientes = 'transferencias-corrientes',
	Subsidios = 'subsidios',
	InteresDeLaDeuda = 'interés-de-la-deuda',
}

export enum EIncomeOriginTypeCapital {
	Inversiones = 'inversiones',
	OtrosGastosDeCapital = 'otros-gastos-de-capital',
	TransferenciasDeCapital = 'transferencias-de-capital',
	AmortizacionDeLaDeuda = 'amortización-de-la-deuda',
}

export enum EProvince {
	BocasDelToro = 'bocas-del-toro',
	Cocle = 'coclé',
	Colon = 'colón',
	Chiriqui = 'chiriquí',
	Darien = 'darién',
	Herrera = 'herrera',
	LosSantos = 'los-santos',
	Panama = 'panamá',
	Veraguas = 'veraguas',
	PanamaOeste = 'panamá-oeste',
}
